import PropTypes from 'prop-types';
import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Typography } from '@telus-uds/components-web';
import { BoldFieldLabel, InputWrapper, InputTitle } from './css';

const modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' }
    ],
    ['link', 'image'],
    [{ color: [] }, { background: [] }],
    ['clean'],
    [{ table: 'add-table' }]
  ]
};

const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
  'color',
  'background' // Add color and background to the formats
];

const FieldRichText = ({ data }) => {
  const {
    ref,
    name,
    label,
    value,
    title,
    required,
    placeholder,
    onChange,
    readonly,
    disabled
  } = data;

  return (
    <InputWrapper>
      {title && <InputTitle>{title}</InputTitle>}
      <BoldFieldLabel>
        <Typography block heading="h4" variant={{ size: 'h4', bold: true }}>
          {label}
          {required && `*`}
        </Typography>
      </BoldFieldLabel>
      <ReactQuill
        ref={ref}
        placeholder={placeholder}
        theme="snow"
        value={value}
        onChange={e => {
          if (e.replace(/<(.|\n)*?>/g, '').trim().length === 0) {
            onChange({ target: { value: '', name } });
          } else onChange({ target: { value: e, name } });
        }}
        modules={modules}
        formats={formats}
        disabled={disabled || readonly}
      />
    </InputWrapper>
  );
};

FieldRichText.propTypes = {
  data: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    ref: PropTypes.object,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    title: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    noteAppearsBelowField: PropTypes.bool.isRequired
  }).isRequired
};

export default FieldRichText;
